import React from 'react';

const UserDetails = ({ user }) => {
    return (<>
        <div>Username: {user.username}</div>
        <div>Email: {user.email}</div>
        <div>Permissions: {user.permissions}</div>
    </>)
}

export default UserDetails;